import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Phone, Scissors, ArrowRight } from "lucide-react";
import { BUSINESS } from "../data/site";
import { FadeUp } from "./Reveal";
import { useCoupons, FALLBACK_COUPON, discountText } from "../hooks/useCoupons";

export const Coupon = () => {
  const coupons = useCoupons();
  const c = coupons && coupons.length > 0 ? coupons[0] : FALLBACK_COUPON;

  return (
    <section id="coupon" data-testid="coupon-section" className="py-20 md:py-28 bg-white border-t border-line">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <FadeUp>
          <motion.div
            data-testid="coupon-ticket"
            whileHover={{ scale: 1.01 }}
            transition={{ type: "spring", stiffness: 220, damping: 18 }}
            className="relative max-w-3xl mx-auto border-2 border-dashed border-volt rounded-lg bg-white px-8 py-12 md:px-14 md:py-14 text-center"
          >
            <Scissors className="absolute -top-4 -right-4 w-8 h-8 text-volt bg-white p-1" aria-hidden="true" />
            <span className="absolute -left-4 top-1/2 -translate-y-1/2 w-8 h-8 bg-white border-r-2 border-dashed border-volt rounded-full" aria-hidden="true" />
            <span className="absolute -right-4 top-1/2 -translate-y-1/2 w-8 h-8 bg-white border-l-2 border-dashed border-volt rounded-full" aria-hidden="true" />

            <p className="font-mono text-xs font-bold uppercase tracking-[0.24em] text-slate-500">Special Offer</p>
            <p className="mt-4 font-display font-black uppercase leading-none text-6xl md:text-7xl text-volt" data-testid="coupon-discount">
              {discountText(c)}
            </p>
            <p className="mt-2 font-display font-black uppercase tracking-tight text-2xl md:text-3xl text-ink">
              {c.title}
            </p>
            {c.description && <p className="mt-5 text-slate-600 max-w-md mx-auto">{c.description}</p>}
            <div className="mt-8 flex flex-wrap items-center justify-center gap-3.5">
              <a
                data-testid="coupon-call-button"
                href={BUSINESS.phoneHref}
                className="inline-flex items-center gap-2.5 bg-gradient-to-r from-cta to-[#F59E0B] text-ink rounded-full font-display font-bold uppercase tracking-wide text-sm px-8 py-4 shadow-lg shadow-cta/40 hover:brightness-95 hover:-translate-y-1 transition-[background-color,transform] duration-300"
              >
                <Phone className="w-4 h-4" />
                Call to Redeem — {BUSINESS.phone}
              </a>
              <Link
                data-testid="coupon-viewall-link"
                to="/coupons"
                className="inline-flex items-center gap-2 border border-volt/40 text-volt bg-white/80 rounded-full font-display font-bold uppercase tracking-wide text-sm px-8 py-4 hover:bg-volt hover:text-white transition-[background-color,color] duration-300"
              >
                All Coupons <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
            {c.terms && (
              <p data-testid="coupon-terms" className="mt-7 font-mono text-[11px] text-slate-400">
                {c.terms}
              </p>
            )}
          </motion.div>
        </FadeUp>
      </div>
    </section>
  );
};
